import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import styles from './BuyMoreButton.module.css';

interface BuyMoreButtonProps {
  className?: string;
}

export const BuyMoreButton: React.FC<BuyMoreButtonProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Перенаправляем на страницу пополнения баланса
    navigate({ to: '/shop/cash' });
  };

  return (
    <button 
      className={`${styles.buyMoreButton} ${className || ''}`}
      onClick={handleClick}
      aria-label="Buy more currency"
    >
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="4" width="2" height="10" fill="#F2EB56" />
        <rect
          x="10"
          y="4"
          width="2"
          height="10"
          transform="rotate(90 10 4)"
          fill="#F2EB56"
        />
      </svg>
    </button>
  );
};